module.exports = __webpack_public_path__ + "static/staticSectionImage1-2d50794c9b1dc0e2d4d26d1f5f3a0287.png";